import React from 'react'
import Auth from '../modules/auth'
import SOP from '../modules/sop'
import Open from '../modules/open'

export function renderRoute(props) {
   
   const {route} = props
   
   switch (route.name) {
    case 'planmanager':
      return <Open {...props}/>
    case 'sop':
      return <SOP {...props}/>
    case 'auth':
      return <Auth {...props}/>
    default:
      return <Auth {...props}/>
   }

  
}
